// Conversation sidebar sections the fork adds: ContactPanel.vue lists them with its own (draggable, in the agent's
// order) and renders them with CustomSidebarItem.vue
export const CUSTOM_CONVERSATION_SIDEBAR_ITEMS = Object.freeze([
  { name: 'pixta_customer' },
]);

export const isCustomSidebarItem = name =>
  CUSTOM_CONVERSATION_SIDEBAR_ITEMS.some(item => item.name === name);
